import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IonButton, IonToast, IonIcon, IonLoading } from "@ionic/react";
// Actions
import parsePaymentNoticesFile from "../../../store/paymentNoticesList/actions/parsePaymentNoticesFile";
// Selectors
import { selectParseFileStatus } from "../../../store/paymentNoticesList/selectors/selectParseFileStatus";
// Icons
import { cloudUploadOutline } from "ionicons/icons";

export const PaymentNoticeCreateButton: React.FC = () => {
  const dispatch = useDispatch();
  const fileInput = useRef(null);
  const parseFileStatus = useSelector(selectParseFileStatus);

  const onSelectFile = async (event: any) => {
    try {
      await dispatch(parsePaymentNoticesFile(event.target.files[0]));
      event.target.value = null;
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <input ref={fileInput} hidden type="file" onChange={onSelectFile} />
      <IonButton
        onClick={() => {
          // @ts-ignore
          fileInput?.current?.click();
        }}
        color="tertiary"
      >
        Importar cartola
        <IonIcon slot="end" icon={cloudUploadOutline}></IonIcon>
      </IonButton>

      <IonLoading
        isOpen={parseFileStatus === "pending"}
        message={"Analizando archivo..."}
      />

      <IonToast
        isOpen={parseFileStatus === "fulfilled"}
        message="Abonos importados exitosamente"
        position="bottom"
        onWillDismiss={() =>
          dispatch({
            type: "paymentNoticesList/setParseFileStatus",
            payload: "initial",
          })
        }
        duration={6000}
        color="success"
      />

      <IonToast
        isOpen={parseFileStatus === "rejected"}
        message="Ocurrió un problema con la importación"
        position="bottom"
        onWillDismiss={() =>
          dispatch({
            type: "paymentNoticesList/setParseFileStatus",
            payload: "initial",
          })
        }
        duration={6000}
        color="danger"
      />
    </>
  );
};
